import React, { Component } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './RolesForm';
import RolesForm from './RolesForm';
import './RolesCrear.css';
import { viewPermissionMap } from './Utils';

export default class RolCrear extends Component {
    state = {
        editar: false,
    };
    componentDidMount() {
        if (this.props.match.params.id) {
            this.props.leer(this.props.match.params.id);
            this.setState({ editar: true });
        }
    }
    actualizar = (data) => {
        // para guardar la vista inicial correctamente entre summary y configuration
        const initialView = data.initial_view;

        // dado a que initialView es summary, verificar que sí se haya seleccionado el módulo
        const initialViewSearch = viewPermissionMap[initialView];
        const DataObjectKeys = Object.keys(data);

        const moduloSeleccionadoVistaInicial = DataObjectKeys.filter(key =>
            key.includes(initialViewSearch) && data[key]
        );

        // si no se seleccionó summary, mínimo se seleccionó la vista de configuración
        // entonces se guarda la vista de configuración
        if (!moduloSeleccionadoVistaInicial.length) {
            data["initial_view"] = initialView.replace('summary', 'configuration');
        }

        this.props.editar(this.props.match.params.id, data);
    };
    getPermissions = () => {
        const { getMe } = this.props;
        getMe();
    }
    render() {
        const { crear, editar } = this.props;
        const { updateData, loader } = this.props;
        return (
            <div className="mb-4 col-12">
                <CardForm
                    icon="configuraciones_activo.png"
                    titulo="ADMINISTRACIÓN"
                    subtitulo="ROL"
                    subtituloForm={this.state.editar ? "Editar" : "Nuevo"}
                    col="11"
                >
                    <LoadMask loading={loader} blur>
                        {
                            this.state.editar ?
                                <RolesForm
                                    onSubmit={this.actualizar}
                                    updateData={updateData}
                                    editando={true}
                                    permisos={this.getPermissions} />
                                :
                                <Form onSubmit={crear} />
                        }
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
